import {
    Alert,
    AlertTitle,
    Collapse,
    FormControlLabel,
    FormGroup,
    Switch,
} from '@mui/material'
import { DropPaper } from '../DropPaper'

export const ExternalMinterEditor = ({
    useExternalMinter,
    setUseExternalMinter,
}) => {
    return (
        <DropPaper>
            <div className="text-2xl mb-5">External Minter Settings</div>
            <div className="my-5">
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={useExternalMinter}
                                onChange={() => {
                                    setUseExternalMinter(!useExternalMinter)
                                }}
                            />
                        }
                        label="Use external minter"
                    />
                </FormGroup>
            </div>
            <Collapse in={useExternalMinter}>
                <Alert severity="warning">
                    <AlertTitle>Caution!</AlertTitle>This is an advanced
                    setting! If you set this to true,{' '}
                    <b>we will not mint any assets for you!</b> Instead you will
                    have to provide your own miniting engine that will combine
                    the layers and mint the assets!
                </Alert>
            </Collapse>
        </DropPaper>
    )
}
